import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { COLLAPSE_PERMISSIONS_ROLE } from "./constants";
export var en = /*#__PURE__*/_defineProperty({}, COLLAPSE_PERMISSIONS_ROLE, {
  STEP_3_TOOLS_TAG: '{{total}} access',
  STEP_3_TABLE_COLUMN_1: 'Tool',
  STEP_3_TABLE_COLUMN_2: 'Configure and view results',
  STEP_3_TABLE_COLUMN_3: 'View results',
  STEP_3_TABLE_COLUMN_4: 'No access',
  STEP_3_TABLE_NO_APPLY: 'Not applicable (Not an editable tool)'
});